import { render, staticRenderFns } from "./CRMButton.vue?vue&type=template&id=77e4d2f2&scoped=true&"
import script from "./CRMButton.vue?vue&type=script&lang=js&"
export * from "./CRMButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77e4d2f2",
  null
  
)

export default component.exports